import Route from "vue-routisan";
import vuex from "@/vuex";
import isAuthenticated from "../middlewares/isAuthenticated";
import isRiskManager from "../middlewares/isRiskManager";
import hasIntegraPermission from "@/http/routes/middlewares/hasPermission/hasIntegraPermission";

Route.group({}, () => {
  Route.group({prefix: "logistic_manager", beforeEnter: [isAuthenticated,hasIntegraPermission]}, () => {

    Route.group({prefix: "risk_manager", beforeEnter: [isRiskManager]}, () => {

      Route.redirect("/", to => {
        return {name: "risk_manager.dashboard"};
      });

      Route.view("/dashboard", () =>
        import(/* webpackChunkName: "risk_manager" */ "@/resources/views/logistic_manager/riskManager/order/OrderList.vue")
      ).name("risk_manager.dashboard");

      Route.view("/order/:id", () =>
        import(/* webpackChunkName: "risk_manager" */ "@/resources/views/logistic_manager/riskManager/order/OrderUpdate.vue")
      ).name("risk_manager.order_update");

      /*---------------------------------------------------------------------------------------------------------------
    |                                               USERS                                                          |
    ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "user"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "risk_manager" */ "@/resources/views/logistic_manager/riskManager/user/UserList")
        ).name("risk_manager.user");
        Route.view("/create", () =>
          import(/* webpackChunkName: "risk_manager" */ "@/resources/views/logistic_manager/riskManager/user/UserCreate")
        ).name("risk_manager.user_create");
        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "risk_manager" */ "@/resources/views/logistic_manager/riskManager/user/UserUpdate")
        ).name("risk_manager.user_update");
      });

    });
  });
});

export default Route.all();
